import AccountPage from "./AccountPage";
import RolePage from "./RolePage";
import PermissionPage from "./PermissionPage";
import ProvincePage from "./ProvincePage";
import CityPage from "./CityPage";
import DistrictPage from "./DistrictPage";
import VillagePage from "./VillagePage";
import UnitPage from "./UnitPage";
import StorePage from "./StorePage";
import CategoryMasterPage from "./CategoryPage/CategoryMasterPage";
import ProductCategoryPage from "./CategoryPage/ProductCategoryPage";
import MaterialCategoryPage from "./CategoryPage/MaterialCategoryPage";
import CategoryTypePage from "./CategoryTypePage";
import OutletPage from "./OutletPage";

const Master = {
  AccountPage,
  RolePage,
  PermissionPage,
  ProvincePage,
  CityPage,
  DistrictPage,
  VillagePage,
  UnitPage,
  StorePage,
  CategoryMasterPage,
  ProductCategoryPage,
  MaterialCategoryPage,
  CategoryTypePage,
  OutletPage,
};

export default Master;
